import Vue from 'vue'; 
import BootstrapVue from 'bootstrap-vue';
import App from '@/App';
import router from '@/router';
import globalComponents from '@/main_components';
import constants from '@/assets/environments/constants.json';
import VueSession from 'vue-session';
import VueResource from 'vue-resource'
import VueExcelXlsx from "vue-excel-xlsx"
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/bootstrap-4.3.1/css/bootstrap.css';
import '@/assets/css/style.css';


import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


library.add(faCoffee)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(router)
Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(VueSession)
Vue.use(globalComponents)
Vue.use(VueExcelXlsx);
Vue.prototype.$bus = new Vue();
Vue.prototype.$constants = constants;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js